<template>
  <div class="set-nav">
    <div class="set-nav_item">
      <div class="set-nav_title">账户信息</div>
      <div class="router-list white-bg">
        <router-link to="/settings/person">个人中心</router-link>
        <!-- <router-link to="/wallet">我的钱包</router-link> -->
        <!-- <router-link to="/news">消息通知</router-link> -->
        <router-link to="/inquire/list">我的咨询</router-link>
        <router-link to="/settings/infomation">个人信息</router-link>
        <router-link to="/settings/security">安全设置</router-link>
        <router-link to="/goods/foot">我的足迹</router-link> 
        <router-link to="/goods/collection">商品收藏</router-link>
      </div>
    </div>
    <div class="set-nav_item">
      <div class="set-nav_title">交易管理</div>
      <div class="router-list white-bg">
        <router-link to="/order/list">我的订单</router-link>
        <!-- <router-link to="/sale">售后服务</router-link> -->
      </div>
    </div>
    <div class="set-nav_item">
      <div class="set-nav_title">通用管理</div>
      <div class="router-list white-bg">
        <router-link to="/settings/address">地址管理</router-link>
        <!-- <router-link to="/settings/invoice">发票管理</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  // components: {},

  // computed: {},

  // mounted: {},

  // methods: {}
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.set-nav {
  width: 202px;
  border-top: 1px solid @eee;
  .set-nav_title {
    width: 202px;
    height: 44px;
    line-height: 44px;
    padding: 0 23px;
    font-weight: bold;
    background: @f9;
    border-left: 1px solid @eee;
    border-right: 1px solid @eee;
    
  }
  .router-list {
    border: 1px solid @eee;
    a {
      color: @gray3;
      display: block;
      height: 44px;
      line-height: 44px;
      padding-left: 40px;
      position: relative;
      &::before {
        content: "";
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: @yellow;
        position: absolute;
        left: 33px;
        top: 20px;
      }
      &.router-link-active {
        color: @yellow;
        &::before {
          width: 0;
          height: 0;
        }
        &::after {
          content: "";
          width: 4px;
          height: 30px;
          background: @yellow;
          position: absolute;
          left: 0;
          top: 7px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SettingNav.vue